export default {
    regular: 1,
    userIn: 1000,
    userOut: 1001
}